const PREFIX = 'MEMBER_AREA_';

export const SET_MEMBER_HAS_ACTIVE_FACILITY_ENROLLMENTS = `${PREFIX}SET_MEMBER_HAS_ACTIVE_FACILITY_ENROLLMENTS`;
export const CHECK_MEMBER_HAS_ACTIVE_FACILITY_ENROLLMENTS = `${PREFIX}CHECK_MEMBER_HAS_ACTIVE_FACILITY_ENROLLMENTS`;
export const GET_MEMBER_INVALIDATIONS = `${PREFIX}GET_MEMBER_INVALIDATIONS`;
export const SET_MEMBER_INVALIDATIONS = `${PREFIX}SET_MEMBER_INVALIDATIONS`;
export const RESIGN_MEMBER_LEGAL_CONTRACT = `${PREFIX}RESIGN_MEMBER_LEGAL_CONTRACT`;

